import type { Editor } from '@tiptap/core'
import type { OutstandingCalloutRange } from './collectOutstandingCalloutRanges'

export function scrollToOutstandingCallout({
  hit,
  editor,
  scrollContainer,
}: {
  hit: OutstandingCalloutRange
  editor: Editor
  scrollContainer: HTMLElement
}): void {
  if (editor.isDestroyed) {
    return
  }

  const coords = editor.view.coordsAtPos(hit.from)
  const containerRect = scrollContainer.getBoundingClientRect()
  const topWithinContainer =
    coords.top - containerRect.top + scrollContainer.scrollTop
  const targetScrollTop = Math.max(
    0,
    topWithinContainer - scrollContainer.clientHeight / 3
  )

  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  })
}
